<template>
  <v-card class="wrapper table-wrapper pa-0 ma-0">
    <iframe
      id="ai-cfo-frame"
      data-ai-cfo
      :src="iframeSrc"
      class="ai-cfo-frame"
      frameborder="0"
    />
  </v-card>
</template>

<script>
export default {
  name: "aiDashboard",
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  computed: {
    BaseUrl() {
      const is_stage =
        location.host === "abr.abriron.net" || location.hostname === "localhost";
      return is_stage ? "https://src.abriron.net" : "https://src.abriron.com";
    },
    iframeSrc() {
      return `${this.BaseUrl}/ai-cfo/${this.path}`;
    },
  },
  mounted() {
    document.documentElement.classList.add("ai-cfo-no-page-scroll");
    document.body.classList.add("ai-cfo-no-page-scroll");

    const existing = document.querySelector("script[data-ai-cfo-embed]");
    if (existing) {
      existing.remove();
    }

    const script = document.createElement("script");
    script.src = `${this.BaseUrl}/ai-cfo/js/parent-embed.js`;
    script.async = true;
    script.setAttribute("data-ai-cfo-embed", "true");
    document.body.appendChild(script);
    this._embedScript = script;
  },
  beforeDestroy() {
    document.documentElement.classList.remove("ai-cfo-no-page-scroll");
    document.body.classList.remove("ai-cfo-no-page-scroll");
    if (this._embedScript && this._embedScript.parentNode) {
      this._embedScript.parentNode.removeChild(this._embedScript);
    }
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
  overflow: hidden;
}
.ai-cfo-frame {
  width: 100%;
  height: 100% !important;
  min-height: 0 !important;
  border: 0;
  display: block;
}
.table-wrapper {
  min-height: 300px;
}
</style>
